import "./App.css";
import QuranVerses from "./components/quranVerses/QuranVerses";
function App() {

  const sanadBaseUrl = process.env.REACT_APP_SANAD_BASE_URL;
  const styleTag = document.createElement('style');
  let styles = '';

  styles += `
    @font-face {
      font-family: 'surah names';
      src: url('${sanadBaseUrl}quran/surah-names/v1/sura_names.woff2') format('woff2');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  styles += `
    @font-face {
      font-family: 'bismeallah';
      src: url('${sanadBaseUrl}quran/hafs/v2/woff2/p1.woff2') format('woff2');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `;

  for (let i = 1; i <= 604; i++) {
    styles += `
      @font-face {
        font-family: 'p${i}';
        src: url('${sanadBaseUrl}quran/hafs/v1/woff2/p${i}.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `;
  }

  styleTag.innerHTML = styles;
  document.head.appendChild(styleTag);

  return (
    <>
      <QuranVerses />
    </>
  );
}

export default App;
